import React, { PureComponent } from 'react';
import { Field } from 'redux-form';
import * as Components from '../index';

const Text = () => {
  return (
    <div>
      <div className="row">
        <div className="col-xs-12">
          <Field
            className="form-group"
            name="body"
            component={Components.Editor}/>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-4">
          <Field
            className="form-group"
            name="photo1"
            component={Components.Image}/>
        </div>
        <div className="col-xs-4">
          <Field
            className="form-group"
            name="photo2"
            component={Components.Image}/>
        </div>
        <div className="col-xs-4">
          <Field
            className="form-group"
            name="photo3"
            component={Components.Image}/>
        </div>
      </div>
    </div>
  );
};

const Image = () => {
  return (
    <div>
      <div className="row">
        <div className="col-xs-12">
          <Field
            className="form-group"
            name="image"
            component={Components.Image}/>
        </div>
      </div>
    </div>
  );
};

const List = () => {
  return (
    <div className="row">
      <div className="col-xs-12">
        <Components.List/>
      </div>
    </div>
  );
};

const VideoA = () => {
  return (
    <div className="row">
      <div className="col-xs-12">
        <Field
          className="form-group"
          name="videoUrl"
          component="input"/>
      </div>
    </div>
  );
};

const DynamicForm = ({ component }) => {
  switch (component) {
    case 'Text':
      return <Text/>
      break;
    case 'Image':
      return <Image/>
      break;
    case 'List':
      return <List/>
      break;
    case 'Video':
      return <VideoA/>
      break;
    default:
      return (<div>Cannot find Component: {component}</div>);
  }
};

class RenderDynamicForm extends PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const { component } = this.props;
    return (
      <div className="planet-render-form">
        {component ? <DynamicForm component={component}/> :
          <span className="planet-render-form__no-comp">Select component please</span>}
      </div>
    );
  }
}

RenderDynamicForm.propTypes = {};
RenderDynamicForm.defaultProps = {};

export default RenderDynamicForm;



// WEBPACK FOOTER //
// ./src/components/render-dynamic-form/RenderDynamicForm.js